<template>
  <div :class="classes">
    <wt-paged-table :on-request-data="getTableData" :total-size="totalNumber" :page-size="pageSize" :refresh="true" ref="table">
        <wt-table :list="tableData" :labels="tableLabels" >
          <template>
            <el-table-column label="详情">
              <template slot-scope="scope">
                <el-button @click="goDetail(scope.row.orderActionData.order.id)" type="text">详情</el-button>
              </template>
            </el-table-column>
            <slot/>
            <!-- <el-table-column label="操作" v-if="status=='ACTION_REQUIRED'" fixed="right" min-width="200">
              <template slot-scope="scope">
                <slot :row="scope.row"></slot>
              </template>
            </el-table-column> -->
          </template>
        </wt-table>
    </wt-paged-table>
  </div>
</template>

<script>
// 组件class前缀
const prefixCls = 'pt-order-handle-table'

export default {
  name: 'pt-order-handle-table',
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    tableLabels: {
      type: Array,
      default: () => []
    },
    totalNumber: {
      type: Number,
      default: 0
    },
    pageSize: {
      type: Number,
      default: 0
    },
    requestData: {
      type: Function
    },
    status: {
      type: String,
      default: ''
    }
  },
  methods: {
    getTableData (page, next) {
      this.requestData && this.requestData(page, next)
    },
    reload () {
      this.$refs.table.load()
    },
    showReTry () {
      this.$refs.table.showReTry()
    },
    goDetail (orderId) {
      // 跳转详情页面时直接将当前数据通过'value'传递，避免再次加载数据的请求。
      this.$router.push({ name: 'lab-order-detail', params: { id: orderId } })
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */

</style>
